import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import PostAddIcon from "@mui/icons-material/PostAdd";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";

export const superAdminLinks = [
  {
    id: 1,
    text: "Dashboard",
    path: "admindashboard",
    icon: <DashboardIcon />,
  },
  {
    id: 2,
    text: "Onboard",
    path: "suppliermanagement",
    icon: <PersonIcon />,
  },
  {
    id: 3,
    text: "Job",
    path: "jobs",
    icon: <PostAddIcon />,
  },
  {
    id: 4,
    text: "skill",
    path: "skills",
    icon: <PlaylistAddIcon />,
  },
  {
    id: 5,
    text: "customers",
    path: "customers",
    icon: <SupervisorAccountIcon />,
  },
  {
    id: 6,
    text: "cV search",
    path: "cv_search",
    icon: <ManageSearchIcon />,
  },
  {
    id: 7,
    text: "interview Tracking",
    path: "interview_info",
    icon: <RecordVoiceOverIcon />,
  },
];
export const userLinks = [
  {
    id: 1,
    text: "Dashboard",
    path: "supplierdashboard",
    icon: <DashboardIcon />,
  },
  {
    id: 2,
    text: "Candidate",
    path: "candidate_data",
    icon: <PersonIcon />,
  },
];
